module.exports = __webpack_public_path__ + "img/arc.485b6b81.png";